import { SkeletonBox, SkeletonText, SkeletonCircle } from '../primitives';
import '../primitives/Skeletons.css';

const NavBarSkeleton = () => (
  <div className="skeleton-navbar">
    <SkeletonCircle size={32} />
    <SkeletonText widths={['100px']} lineHeight="20px" />
  </div>
);

const DashboardSkeleton = () => {
  return (
    <div aria-hidden="true">
      <NavBarSkeleton />
      <div className="skeleton-dashboard">
        {/* Hero section */}
        <div className="skeleton-dashboard__hero">
          <div className="skeleton-dashboard__hero-text">
            <SkeletonText widths={['200px']} lineHeight="32px" />
            <SkeletonText widths={['300px']} lineHeight="16px" />
          </div>
          {/* Streak widget placeholder */}
          <SkeletonBox width={120} height={80} borderRadius="var(--radius-lg)" />
        </div>

        {/* First grid row - Heatmap and Pie chart */}
        <div className="skeleton-dashboard__grid">
          <div className="skeleton-dashboard__card">
            <SkeletonText widths={['120px']} lineHeight="18px" style={{ marginBottom: 'var(--space-md)' }} />
            <SkeletonBox height={200} />
          </div>
          <div className="skeleton-dashboard__card">
            <SkeletonText widths={['100px']} lineHeight="18px" style={{ marginBottom: 'var(--space-md)' }} />
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
              <SkeletonCircle size={160} />
            </div>
          </div>
        </div>

        {/* Second grid row - Chart and Counts */}
        <div className="skeleton-dashboard__grid">
          <div className="skeleton-dashboard__card">
            <SkeletonText widths={['140px']} lineHeight="18px" style={{ marginBottom: 'var(--space-md)' }} />
            <SkeletonBox height={180} />
          </div>
          <div className="skeleton-dashboard__card">
            <SkeletonText widths={['100px']} lineHeight="18px" style={{ marginBottom: 'var(--space-md)' }} />
            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-md)' }}>
              {[1, 2, 3].map((item) => (
                <div key={item} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <SkeletonText widths={['80px']} lineHeight="16px" />
                  <SkeletonText widths={['50px']} lineHeight="24px" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardSkeleton;
